/* eslint tailwindcss/no-custom-classname: off */
interface Props {
  className?: string
}
export const Free: React.FC<Props> = ({ className }) => {
  return <div className={`${className || ''} lvl free`}>無料</div>
}
